interface IconProps {
  className?: string;
}

/**
 * Lucide "shield-check" glyph. Inlined because the shared sprite
 * (~/components/Icon) does not include it yet. Rendered as a solid
 * brand-colored badge with an inverse checkmark, matching the DubaiExpress
 * USP tile style.
 */
const ShieldCheckIcon = ({ className }: IconProps) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden className={className}>
    <path
      d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
      fill="var(--icon-brand)"
    />
    <path
      d="m9 12 2 2 4-4"
      stroke="var(--icon-inverse-primary)"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ShieldCheckIcon;
